import {createContext} from 'react';
import type {ContainerQueryObject} from '@Hooks/useContainerQuery';
import type {EventWizardContainerQuery} from './event-wizard.types';

export const EVENT_WIZARD_CONTAINER_QUERIES_CONTEXT = createContext<EventWizardContainerQuery>({
  isExtraSmallScreen: undefined,
  isSmallScreen: undefined,
  isMediumScreen: undefined,
  isLargeScreen: undefined,
  isExtraLargeScreen: undefined,
});

export const containerQuery: ContainerQueryObject = {
  xxsmall: {
    maxWidth: 400
  },
  xsmall: {
    minWidth: 0,
    maxWidth: 480,
  },
  small: {
    minWidth: 0,
    maxWidth: 1024,
  },
};
